import { gql } from '@apollo/client';
const MOVE_MODEL_SPECIFICATION_STATUS = gql `
  mutation MoveModelSpecificationStatus($statusId: ID!, $direction: String!) {
    moveModelSpecificationStatus(statusId: $statusId, direction: $direction) {
      statuses {
        id
        namePL
        nameEN
        color
        displayOrder
        canBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default MOVE_MODEL_SPECIFICATION_STATUS;
